import {
  AMBIENTES_PADRAO,
  ATELIE_PADRAO,
  CONTATO_PADRAO,
  DEPOIMENTO_PADRAO,
  HERO_PADRAO,
  PROCESSO_PADRAO,
  SHOWROOM_PADRAO,
  type Ambientes,
  type Atelie,
  type Contato,
  type Depoimento,
  type Hero,
  type Processo,
  type Showroom,
} from '@plane/shared';
import { useQuery } from '@tanstack/react-query';

import {
  fetchAmbientes,
  fetchAtelie,
  fetchContato,
  fetchDepoimento,
  fetchHero,
  fetchProcesso,
  fetchShowroom,
} from '@/services/site-content.service';

/**
 * Conteúdo de uma seção, com queda para o padrão.
 *
 * Devolve sempre algo utilizável, nunca `undefined`: enquanto a consulta está em
 * voo, se a API estiver fora, ou se a seção ainda não tiver sido salva no
 * painel, vale o padrão de `@plane/shared`. O site institucional precisa
 * aparecer inteiro mesmo com a API fora do ar — é o cartão de visitas da
 * marcenaria, não um aplicativo.
 *
 * `retry: false` porque a resposta esperada, enquanto o painel não salvou, é
 * 404: insistir nela só atrasa a queda para o padrão.
 */
function useSecao<T>(chave: string, buscar: () => Promise<T>, padrao: T): T {
  const { data } = useQuery({
    queryKey: ['site-content', chave],
    queryFn: buscar,
    staleTime: 5 * 60_000,
    retry: false,
  });

  return data ?? padrao;
}

export function useAmbientes(): Ambientes {
  return useSecao('ambientes', fetchAmbientes, AMBIENTES_PADRAO);
}

export function useAtelie(): Atelie {
  return useSecao('atelie', fetchAtelie, ATELIE_PADRAO);
}

export function useContato(): Contato {
  return useSecao('contato', fetchContato, CONTATO_PADRAO);
}

export function useDepoimento(): Depoimento {
  return useSecao('depoimento', fetchDepoimento, DEPOIMENTO_PADRAO);
}

export function useHero(): Hero {
  return useSecao('hero', fetchHero, HERO_PADRAO);
}

export function useShowroom(): Showroom {
  return useSecao('showroom', fetchShowroom, SHOWROOM_PADRAO);
}

export function useProcesso(): Processo {
  return useSecao('processo', fetchProcesso, PROCESSO_PADRAO);
}
